import { inputAnatomy } from "@chakra-ui/anatomy";
import { createMultiStyleConfigHelpers, defineStyle } from "@chakra-ui/react";

const { definePartsStyle, defineMultiStyleConfig } =
  createMultiStyleConfigHelpers(inputAnatomy.keys);

const baseStyle = definePartsStyle({
  field: {
    w: "100%",
    h: "34px",
    p: "6px 12px",
    fontSize: "14px",
    lineHeight: "20px",
    color: "#555",
    bgColor: "#fff",
    border: "1px solid #ccc",
    boxShadow: "inset 0 1px 1px rgba(0,0,0,.075)",
    "::placeholder": {
      color: "#9B9EA1"
    },
    _focus: {
      borderColor: "#66afe9",
      outline: 0,
      boxShadow: "inset 0 1px 1px rgba(0,0,0,.075),0 0 8px rgba(102,175,233,.6)",
    },
    _hover: {
      "::placeholder": {},
    },
    _disabled: {
      "::placeholder": {},
    },
    _active: {},
    _invalid: {
      color: "#B94A48",
      bgColor: "#F2DEDE",
      border: "1px solid #EED3D7",
    },
    _valid: {
      color: "#468847",
      bgColor: "#DFF0D8",
      border: "1px solid #D6E9C6",
    }
  },
});


const readonlyInput = definePartsStyle({
  field: {
    display: "inline-block",
    w: "initial",
    h: "23.2px",
    p: "0",
    borderRadius: "0",
    bgColor: "transparent",
    border: "1px solid #ccc",
    mt: "5px",
    _focus: {
      borderColor: "",
      boxShadow: "",
    }
  },
});

const brand = definePartsStyle({});

const inputTheme = defineMultiStyleConfig({
  baseStyle,
  defaultProps: { variant: brand },
  variants: { brand, readonlyInput },
});

export default inputTheme;
